export default __webpack_public_path__ + "images/2f76597a6c57bec6220434698c5f54a7-amex-icon.svg";